import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        d="M5 5.81L8 3l3 2.81-.857.803-1.538-1.44L8.606 13H7.394V5.173l-1.537 1.44L5 5.81z"
      ></path>
    </svg>
  )
}

export default Icon
